/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from 'react';

import { Container, Row, Col } from 'reactstrap';

function AuthFooter() {
  return (
    <>
      <footer className="py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-center">
            <Col xl="12">
              <div className="copyright text-center text-xl-center text-light">
                {/* © {new Date().getFullYear()}{' '} */}
                ©{' '}
                <a
                  className="font-weight-bold ml-1 text-white"
                  href={process.env.REACT_APP_HOMEPAGE}
                  rel="noopener noreferrer"
                  target="_blank"
                  >
                  {process.env.REACT_APP_COPYRIGHT}
                </a>{' '}
                <span className="font-weight-300 text-light">
                  all rights reserved
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default AuthFooter;
